import {
  RootHistory,
  RootLocationDescriptorObject,
} from '@feature-hub/history-service';
import {
  BreadcrumbServiceV1,
  BreadcrumbV1,
} from '@volkswagen-onehub/breadcrumb-service';
import * as React from 'react';
import { Route } from './use-route';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { getTranslations } from '../translations';

export function createBreadcrumb(
  rootHistory: RootHistory,
  location: RootLocationDescriptorObject,
  label: string,
  onClick: () => void
): BreadcrumbV1 {
  return {
    href: rootHistory.createHref(location),
    label,
    onClick,
  };
}

export function useBreadcrumbs(
  breadcrumbService: BreadcrumbServiceV1,
  rootHistory: RootHistory,
  route: Route,
): void {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const trans = getTranslations();
  const urlParams = useParams();

  const onRouteChange = (routeDetails: RootLocationDescriptorObject) => {
    navigate(routeDetails);
  }

  const pushHome = () => {
    return createBreadcrumb(
      rootHistory,
      {pathname: '/'},
      trans.breadcrumb.home,
      () => onRouteChange({pathname: '/'})
    )
  }

  const pushResults = () => {
    return createBreadcrumb(
      rootHistory,
      {pathname: '/results', search: searchParams.toString()},
      trans.breadcrumb.results,
      () => onRouteChange({pathname: '/results', search: searchParams.toString()})
    )
  }

  React.useEffect(() => {
    const params = searchParams;

    params.delete('-');

    const breadcrumbs: BreadcrumbV1[] = [];

    breadcrumbs.push(pushHome());

    if (route === 'results') {
      breadcrumbs.push(pushResults());
    }

    if (route === 'favourites') {

      if(!urlParams.ulid) breadcrumbs.push(pushResults());

      breadcrumbs.push(
        createBreadcrumb(
          rootHistory,
          {pathname: '/favourites'},
          trans.breadcrumb.favourites,
          () => onRouteChange({pathname: '/favourites'})
        ),
      );
    }

    if (route === 'details') { breadcrumbs.push(pushResults()); }

    breadcrumbService.set(breadcrumbs);
  }, [breadcrumbService, route, rootHistory, searchParams]);
}
